import { render, staticRenderFns } from "./productionRight.vue?vue&type=template&id=18198e4e&scoped=true&"
import script from "./productionRight.vue?vue&type=script&lang=js&"
export * from "./productionRight.vue?vue&type=script&lang=js&"
import style0 from "./productionRight.vue?vue&type=style&index=0&id=18198e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18198e4e",
  null
  
)

export default component.exports